import React, { useRef } from "react"
import { useReadMoreButton } from "../../hooks/useReadMoreButton"

const BandTypeRecommended = ({ htmlLeft, htmlRight }) => {
  const bandTypeRecommended = useRef(null)

  useReadMoreButton(bandTypeRecommended, "Read More", "Read Less")

  return (
    <div>
      <div
        className="max-w-screen-2xl w-full mx-auto flex flex-col lg:flex-row justify-around px-7 2xl:px-0 mb-[150px]"
        ref={bandTypeRecommended}
      >
        <div
          className="max-w-lg lg:pr-5"
          dangerouslySetInnerHTML={{ __html: htmlLeft || "" }}
        ></div>
        <div
          className="lg:max-w-3xl leading-[34px]"
          dangerouslySetInnerHTML={{ __html: htmlRight || "" }}
        ></div>
      </div>
    </div>
  )
}

export default BandTypeRecommended
